// tailwind.config.js
module.exports = {
    theme: {
        colors: {
            yellow: {
                '500': '#ebab21' /* Theme Primary */,
                '600': '#d39613' /* Theme Primary Medium */,
                '700': '#b49e12' /* Theme Tertiary (light gold) */,
                '800': '#8c6c28' /* Theme Primary Dark (dark gold) */
            },
            orange: {
                '700': '#da6127' /* Theme Secondary */
            },
            blue: {
                '300': '#5bb4e5',
                '900': '#09142d'
            },
            grey: {
                '100': '#c6c6bc',
                '200': '#ecece9',
                '300': '#b7b7b7' /* Small text color */,
                '400': '#999a8f',
                '500': '#818181' /* Theme Neutral Medium */,
                '600': '#565a5c',
                '700': '#363636',
                '800': '#272727' /* Theme Neutral Dark */
            },
            white: '#ffffff' /* Theme Neutral Light */,
            black: '#000000',
            transparent: 'rgba(0,0,0,0)',
            gray: {}
        },

        fontFamily: {
            serif: ['HCo Sentinel SSm', 'serif'] /* base font and headings */,
            sans: ['HCo Gotham SSm', 'sans-serif'] /* nav, links, taglines, citation */,
            fancy: ['Aguafina Script', 'Helvetica', 'Arial', 'sans-serif'] /* blockquote */
        },

        fontSize: {
            '7xl': '89px',
            '6xl': '80px',
            '5xl': '72px',
            '4xl': '55px',
            '3xl': '48px',
            '2xl': '34px',
            xl: '24px',
            lg: '20px',
            md: '18px',
            base: '16px',
            sm: '14px',
            xs: '12px',
            xxs: '10px'
        },

        lineHeight: {
            none: 1,
            tight: 1.125,
            snug: 1.25,
            normal: 1.5,
            relaxed: 1.625,
            loose: 2
        },

        borderWidth: {
            default: '1px',
            '0': '0',
            '2': '2px',
            '3': '3px',
            '5': '5px',
            '6': '6px',
            '8': '8px'
        },

        extend: {
            rotate: {
                '-5': '-5deg'
            },

            inset: {
                '1/2': '50%',
                full: '100%',
                7: '1.75rem',
                20: '5rem'
            },

            minHeight: {
                650: '650px',
                750: '750px'
            },

            maxHeight: {
                0: '0',
                650: '650px'
            },

            height: {
                85: '85vh',
                500: '500px'
            },

            padding: {
                '16/9': '56.25%',
                full: '100%'
            },

            zIndex: {
                '-1': '-1'
            }
        },

        customForms: (theme) => ({
            default: {
                'input, textarea, select': {
                    width: '100%',
                    fontSize: theme('fontSize.sm'),
                    borderColor: theme('colors.grey.700'),
                    padding: `0 ${theme('spacing.6')}`,
                    lineHeight: '48px'
                },
                'checkbox, radio': {
                    color: theme('colors.orange.500'),
                    borderColor: theme('colors.grey.700')
                }
            }
        })
    },
    variants: {
        opacity: ['group-hover'],
        backgroundColor: ['responsive', 'hover', 'group-hover'],
        backgroundOpacity: ['group-hover'],
        translate: ['group-hover'],
        visibility: ['responsive', 'group-hover'],
        scale: ['group-hover'],
        maxHeight: ['responsive', 'group-hover'],
        display: ['responsive', 'last'],
        margin: ['responsive', 'last'],
        padding: ['responsive', 'last'],
        textColor: ['responsive', 'hover', 'focus', 'last'],
        borderWidth: ['responsive', 'last']
    },
    corePlugins: {
        container: false
    },
    future: {
        removeDeprecatedGapUtilities: true
    },
    plugins: [require('@tailwindcss/custom-forms')],
    purge: ['./app/**/*.html', './app/**/*.twig', './app/**/*.js', './app/**/*.vue']
};
